import { isObject } from 'lodash';
import { GetLanguageSet_translations_getLanguageSet_data_languageCounts as LanguageCounts } from 'translations/queries/__generated__/GetLanguageSet';

export function stripTypename<U extends T, T extends { __typename: string }>(
  input: T
): Pick<T, Exclude<keyof T, '__typename'>> {
  if (!isObject(input)) {
    return input;
  }

  const { __typename, ...rest } = input;
  return rest as U;
}

// Merges the languageCounts of each group into a singular count for each language
// ex. [{languageCode: fr, count: 4}, {languageCode: fr, count: 2}] => [{languageCode: fr, count: 6}]
// This is because in announcements, these two results could be coming from two different groups
export function mergeLanguageResults(languageCounts: LanguageCounts[]): LanguageCounts[] {
  const result = languageCounts.reduce(
    (acc: { [key: string]: number }, current: LanguageCounts) => {
      acc[current.languageCode] = ~~acc[current.languageCode] + current.count;
      return acc;
    },
    {}
  );
  return Object.keys(result).map(key => ({
    __typename: 'LanguageCount',
    languageCode: key,
    count: result[key],
  }));
}
